if (typeof WDN == "undefined") var WDN = {};
typeof WDN.CarCollection == "undefined" &&
    (WDN.CarCollection = (function () {
        var r = {},
            i = function (t, e, o) {
                (this.parent = t),
                    (this.selector = this.parent.querySelector('select[data-id="'.concat(e, '"]'))),
                    (this.output = this.parent.querySelector("select[data-id='".concat(o, "']"))),
                    (this.outputParent = this.parent.querySelector(".Custom__properties-select[data-id='".concat(o, "']"))),
                    (this.labelList = this.parent.querySelectorAll(".Custom__properties-label_value")),
                    (this.id = e),
                    this.start();
            },
            n = { parent: ".Custom__properties" },
            s = function (t, e) {
                var o = document.querySelector("".concat(n.parent));
                o && (r[t] = new i(o, t, e));
            };
        return (
            (i.prototype.start = function () {
                this.bind();
            }),
            (i.prototype.updateActive = function () {
                this.active = this.selector.options[this.selector.selectedIndex].value;
            }),
            (i.prototype.bind = function () {
                this.selector.addEventListener("change", this.update.bind(this));
            }),
            (i.prototype.update = function () {
                this.updateActive(),
                    (this.models = Models.filter(function (t) {
                        if (t.Brand === this.active) return t;
                    }, this)[0]),
                    this.updateLabel(),
                    this.render();
            }),
            (i.prototype.updateLabel = function () {
                this.labelList.forEach(function (t) {
                    t.innerHTML = this.active;
                }, this),
                    (this.output.name = "properties[".concat(this.active, " Model]"));
            }),
            (i.prototype.render = function () {
                var t = this.models.Models.split(/[,]+/);
                (this.output.innerHTML = ""), this.outputParent.classList.remove("Hide"), (this.output.innerHTML += '<option value="" disabled selected>'.concat(Translations.choose_one, "</option>"));
                for (var e = 0; e < t.length; e++) this.output.innerHTML += '<option value="'.concat(t[e], '">').concat(t[e], "</option>");
            }),
            { Create: s }
        );
    })()),
    WDN.CarCollection.Create("brand", "model");

